import DashboardHeader from "../../components/dashboardHeader/DashboardHeader";
import useAccessToken, {getPayloadFromAccessToken} from "../../hooks/useToken";
import PrimarySelect from "../../components/primarySelect/PrimarySelect";
import {useEffect} from "react";
import interruptAuth from "../../utils/Interrupt_auth";
import {useNavigate} from "react-router-dom";
import {useDashboardLocale} from "../../context/dashboard_locale";
import {capitalize} from "../../utils/strings";
import {fetchDashboardLanguages} from "../../services/api/Languages";

export default function Settings() {
    const {strings, langCode, changeLocale} = useDashboardLocale()
    const dashboardLanguages = fetchDashboardLanguages()
    let languageOptions = dashboardLanguages.map(function (language) {
            return {
                value: language.code,
                title: language.name,
            }
        }
    )
    const defaultLanguageOption = languageOptions.find(function (languageOption) {
        return languageOption.value === langCode
    })
    console.log(defaultLanguageOption)
    let {token} = useAccessToken()

    let tokenPayload = null
    if (token) {
        tokenPayload = getPayloadFromAccessToken(token)
    }
    let accountID = null
    if (tokenPayload) {
        accountID = tokenPayload.ID
    }
    let navigate = useNavigate()

    useEffect(function() {
        interruptAuth(token, navigate)
    }, [])

    function onChangeInterfaceLanguage(e) {
        let langCode = e.target.value
        changeLocale(langCode)
    }

    return (
        <div className="flex flex-col min-h-screen">
            <DashboardHeader />
            <div className='flex flex-grow'>
                <div className="container flex items-start flex-col gap-6 mx-auto px-2 shadown-md bg-white text-left px-8 py-6">
                    <div className="w-full flex items-center gap-3 flex row-flex justify-between">
                        <p className="text-lg font-semibold">{strings["account_id"]}</p>
                        <p className="text-lg font-bold text-left">{accountID}</p>
                    </div>
                    <div className="w-full flex items-center gap-3 flex row-flex justify-between">
                        <p className="text-lg font-semibold">{capitalize(strings["interface_language"])}</p>
                        <PrimarySelect
                            defaultOption={defaultLanguageOption}
                            onChange={onChangeInterfaceLanguage}
                            options={languageOptions}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}